import {defineAbilityConfig} from '../system/defineAbilityConfig';
import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';

/**
 * Ability to access Agents mode
 *
 * Note: This is an in-progress feature currently gated by feature flag.
 * Additional restrictions (workflows, siteModes, entitlements) can be added
 * as the feature matures.
 */
export const canAccessAgentsMode = defineAbilityConfig({
  abilities: {canAccessAIFeatures: true},
  permission: ['read', 'siteAgenticWorkflows'],
  userTypes: {
    authorizedInDesigner: true,
    unauthorized: false,
  },
  featureFlags: {
    [FEATURE_FLAGS.AI_WORKFLOWS_UI]: true,
  },
} as const);

export const canAccessAgentIntegrationsPanel = defineAbilityConfig({
  abilities: {canAccessAgentsMode: true},
  featureFlags: {
    [FEATURE_FLAGS.AI_WORKFLOWS_M1]: true,
  },
} as const);

/** Gates mutation controls for agent workflows (create, edit, delete, run). */
export const canManageAgentWorkflows = defineAbilityConfig({
  abilities: {canAccessAgentsMode: true},
  permission: ['manage', 'siteAgenticWorkflows'],
} as const);
